import { Tabs as ChakraTabs } from "@chakra-ui/react";
import type { ComponentProps } from "react";
import type { TabSharedProps } from "./Tab.props";

export default function Tab(props: TabProps): JSX.Element {
  // Extract props explicitly so we can control prop names in one place
  const { isDisabled, disabled, value, ...rest } = props;

  // Map v1/v2 props to v3 props for backward compatibility
  const disabledValue = disabled !== undefined ? disabled : isDisabled;

  return (
    <ChakraTabs.Trigger
      value={value ?? "0"}
      disabled={disabledValue}
      borderRadius="xs"
      borderBottom="none"
      padding="none"
      css={{
        span: {
          paddingBottom: "12px",
          fontSize: "14px",
          borderBottom: "1px solid",
          borderColor: "var(--chakra-colors-gray-400)",
        },
        "&[data-selected]": {
          span: {
            color: "var(--chakra-colors-primary-700)",
            borderBottom: "2px solid",
            borderColor: "var(--chakra-colors-primary-700)",
          },
        },
      }}
      {...rest}
    />
  );
}

type ChakraTriggerProps = ComponentProps<typeof ChakraTabs.Trigger>;

export type TabProps = TabSharedProps &
  Omit<ChakraTriggerProps, "value" | "disabled"> & {
    // Add any web specific props here.
    value?: string;
    disabled?: boolean;
  };
